<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <el-breadcrumb class="target" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/online' }">在线练习</el-breadcrumb-item>
        <el-breadcrumb-item>习题详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="cont bs">
        <h3 class="total">安管考试考核A在线练习共（60）题</h3>
        <div class="theme">
          <div class="theme-l">
            <div class="theme-top">
              <h3 class="title">1. 施工现场用电工程中，PE线的重复接地点不应少于（ ）。</h3>
              <el-radio-group v-model="radio" class="choose">
                <el-radio :label="1" style="width: 500px">A. 备选项选项备选项备选项</el-radio>
                <el-radio :label="2">B. 备选项备选项备选项备选项备选项备选项</el-radio>
                <el-radio :label="3">C. 备选项</el-radio>
                <el-radio :label="4">D. 备选项</el-radio>
              </el-radio-group>
            </div>
            <el-row class="switch">
              <el-button type="primary">上一题</el-button>
              <el-button type="warning">下一题</el-button>
              <el-button type="danger" @click="paper">交卷</el-button>
            </el-row>
          </div>
          <div class="answer bs">
            <h3 class="top">答题卡</h3>
            <ul class="choose-list">
              <li v-for="(item, i) in 3" :key="i">
                <h3 class="list-tit">选择题</h3>
                <span class="menu cur" v-for="(item, j) in 18" :key="j">
                  {{
                  j + 1
                  }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";

export default {
  name: "Exercise",
  data() {
    return {
      radio: 1
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  methods: {
    paper() {
      this.$confirm("是否确定交卷?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$router.push({
            path: '/viewResult'
          })
        })
        .catch(() => {
          this.$message.info({
            duration: 1000,
            message: "已取消交卷"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
.target {
  line-height: 60px;
}
.cont {
  width: 100%;
  border-radius: 6px;
  background: #ffffff;
  padding: 0 20px;
}
.total {
  width: 100%;
  line-height: 80px;
  font-size: 24px;
  font-weight: normal;
  color: #2c3e50;
  border-bottom: 1px solid #ddd;
}
.theme {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  .theme-l {
    width: 860px;
    padding: 0 20px;
    .choose {
      padding-bottom: 20px;
    }
    .theme-top {
      border-bottom: 1px solid #dddddd;
    }
    .switch {
      padding: 20px;
      text-align: center !important;
    }
  }
  .title {
    line-height: 40px;
    color: #2c3e50;
  }
}
.answer {
  width: 280px;
  border-radius: 6px;
  max-height: 500px;
  overflow-y: scroll;
  .top {
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
  }
  .choose-list {
    padding: 20px;
    li {
      padding-bottom: 20px;
    }
  }
  .list-tit {
    line-height: 30px;
  }
  .menu {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    color: #2c3e50;
    text-align: center;
    line-height: 30px;
    margin: 8px;
    // &:nth-child(5n){
    //   margin-right: 0;
    //   margin-left: 8px;
    // }
  }
}
</style>
